import { render, staticRenderFns } from "./ShippingMethodItem.vue?vue&type=template&id=87728366&"
import script from "./ShippingMethodItem.vue?vue&type=script&lang=js&"
export * from "./ShippingMethodItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports